import fetch from "auth/FetchInterceptor";

const UserService = {};

UserService.fetchProfile = () =>
  fetch({
    url: `profile`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

UserService.getAvailableRoles = (params) =>
  fetch({
    url: `users/miscs/roles`,
    method: "GET",
    params,
  });

export default UserService;
